export const EVENT_DATE_TIME_FORMAT = 'DD/MM/YYYYTHH:mm:ss';
